<template>
  <!-- Left div because b-navbar does not trigger on mouseenter / mouseleave events -->
  <div
    class="sidenav navbar navbar-vertical fixed-left navbar-dark navbar-expand-xs bg-default"
    @mouseenter="$sidebar.onMouseEnter()"
    @mouseleave="$sidebar.onMouseLeave()"
    :data="backgroundColor"
  >
    <div class="scrollbar-inner" ref="sidebarScrollArea">
      <div class="sidenav-header d-flex align-items-center">
        <b-navbar-brand href="/">
          <img :src="logo" class="navbar-brand-img" alt="RapidAIM" />
        </b-navbar-brand>
        <!--
        <div class="ml-auto">
          <div
            class="sidenav-toggler d-none d-xl-block"
            :class="{ active: !$sidebar.isMinimized }"
            @click="minimizeSidebar"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </div>
        -->
      </div>
      <slot></slot>
      <div class="navbar-inner">
        <p class="build-version" style="font-size: 0.75rem; color: #ffffff; line-height: 1">
          Version: {{ version }}<br />{{ timestamp }}
        </p>
        <b-navbar-nav>
          <slot name="links">
            <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
              <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
              </sidebar-item>
            </sidebar-item>
          </slot>
        </b-navbar-nav>
        <slot name="links-after"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import { build } from 'apiConfig';

export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'RapidAIM',
      description: 'Sidebar title'
    },
    shortTitle: {
      type: String,
      default: 'CT',
      description: 'Sidebar short title'
    },
    logo: {
      type: String,
      default:
        'https://i2.wp.com/rapidaim.io/wp-content/uploads/2019/04/logo-horizontal-reversed-01-2x-contrast.png?fit=395%2C102&ssl=1',
      description: 'RapidAIM'
    },
    backgroundColor: {
      type: String,
      default: 'vue',
      validator: (value) => {
        let acceptedValues = ['', 'vue', 'blue', 'green', 'orange', 'red', 'primary'];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Sidebar background color (vue|blue|green|orange|red|primary)'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description: "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description: 'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  data() {
    return {
      version: build.version,
      timestamp: build.timestamp
    };
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  mounted() {
    this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth;
    this.minimizeSidebar();
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
